import styled from 'styled-components';

interface Props {
  width?: number | string;
}

const StyledDropdown = styled.div<Props>`
  position: relative;
  display: inline-block;
  height: fit-content;

  .menu {
    position: absolute;
    width: ${({ width }) => width ?? 'auto'};
    top: 65px;
    right: 20px;
    z-index: 999;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 9px 28px 0 rgba(0, 0, 0, 0.05),
      0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px 0 rgba(0, 0, 0, 0.12);
    display: block;
    overflow: hidden;
    padding: 4px 0;
  }

  .menu,
  .menu .submenu {
    -webkit-transition: opacity 0.3s,
      max-height 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;
    -moz-transition: opacity 0.3s, max-height 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;
    -ms-transition: opacity 0.3s, max-height 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;
    -o-transition: opacity 0.3s, max-height 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;
    transition: opacity 0.3s, max-height 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;
  }

  .visible {
    max-height: 400px;
    opacity: 1;
  }

  .hidden {
    max-height: 0;
    opacity: 0;
  }

  .menu button,
  .menu small {
    width: 100%;
    background-color: transparent;
    border: none;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    padding: 0 16px;
  }

  .menu button {
    font-size: 14px;
    line-height: 30px;
    color: rgba(0, 0, 0, 0.65);
  }

  .menu small {
    line-height: 16px;
    justify-content: end;
    color: rgba(0, 0, 0, 0.45);
  }

  .menu button a {
    color: rgba(0, 0, 0, 0.65);
  }

  .menu button:hover,
  .menu button a:hover {
    color: rgba(0, 0, 0, 0.85);
  }

  .menu button .anticon {
    line-height: inherit;
  }

  .menu .dropdown-btn .anticon.anticon-down svg {
    -webkit-transition: transform 0.3s;
    -moz-transition: transform 0.3s;
    -ms-transition: transform 0.3s;
    -o-transition: transform 0.3s;
    transition: transform 0.3s;
  }

  .menu .dropdown-btn.active .anticon.anticon-down svg {
    transform: rotate(180deg);
  }

  .menu .submenu.hidden button {
    visibility: hidden;
  }

  .menu .submenu button.active {
    cursor: initial;
    background-color: #e5f2e4;
  }
`;

export default StyledDropdown;
